import React, { useEffect, useRef } from 'react';

const FullHtmlComponent = (props) => {
  const { data } = props;
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    // Scripts injected via innerHTML are not executed by the browser.
    // Find each <script> and replace it with a freshly created element,
    // which forces the browser to run it. Keep references to the elements
    // we create so we can remove them when the HTML changes or unmounts.
    const oldScripts = Array.from(container.querySelectorAll('script')).filter(
      // Defensive: only re-create scripts that actually live inside our
      // container, and never anything explicitly marked as app-owned.
      (script) =>
        container.contains(script) &&
        !script.hasAttribute('data-app-script')
    );
    const createdScripts = [];

    oldScripts.forEach((oldScript) => {
      const newScript = document.createElement('script');

      // Copy attributes (src, type, async, etc.).
      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });

      // Copy inline script content.
      newScript.textContent = oldScript.textContent;

      oldScript.parentNode.replaceChild(newScript, oldScript);
      createdScripts.push(newScript);
    });

    // On re-run (data.html changed) or unmount, remove the script elements
    // we added so they don't pile up. NOTE: this only removes the <script>
    // nodes themselves — side effects an external script may have caused
    // (globals, listeners on window/document, injected nodes, timers)
    // cannot be undone generically and must be cleaned up by that script.
    return () => {
      createdScripts.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, [data.html]);

  return (
    <div
      ref={containerRef}
      style={{ display: 'content' }}
      dangerouslySetInnerHTML={{ __html: data.html }}
    ></div>
  );
};

export default FullHtmlComponent;
